// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-card {
  border: 2px solid #264ec8;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 50px;
  height: 440px;
}

.blog-cover-img {
  overflow: hidden;
  height: 200px;
}

.blog-image {
  border-radius: 10px;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: top;
}
.blog-date {
  text-align: right;
}
.blog-read {
  color: var(--dPink);
}
.blog-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 60%;
  padding-bottom: 40px;
}

.blog-img-wrapper {
  width: 100%;
  height: 40%;
}

.blog-paragraph {
  padding-top: 20px;
  word-wrap: break-word;
}

.blog-title {
  line-height: 1.5;
}

@media (max-width: 1024px) {
  .blog-card {
    height: 440px;
  }

  .blog-paragraph {
    padding-top: 5px;
  }
}
@media (max-width: 576px) {
  .blog-cover-img {
    height: 170px;
  }
  .blog-image {
    object-fit: cover;
  }

  .blog-card {
    height: 335px;
    margin-bottom: 30px;
  }

  .blog-content {
    padding: 20px 15px;
  }

  .blog-paragraph {
    padding-top: 5px;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .blog-card {
    height: 520px;
  }

  .blog-title {
    line-height: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/BlogCard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".blog-card {\r\n  border: 2px solid #264ec8;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  margin-bottom: 50px;\r\n  height: 440px;\r\n}\r\n\r\n.blog-cover-img {\r\n  overflow: hidden;\r\n  height: 200px;\r\n}\r\n\r\n.blog-image {\r\n  border-radius: 10px;\r\n  height: 100%;\r\n  width: 100%;\r\n  object-fit: cover;\r\n  object-position: top;\r\n}\r\n.blog-date {\r\n  text-align: right;\r\n}\r\n.blog-read {\r\n  color: var(--dPink);\r\n}\r\n.blog-content {\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  height: 60%;\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.blog-img-wrapper {\r\n  width: 100%;\r\n  height: 40%;\r\n}\r\n\r\n.blog-paragraph {\r\n  padding-top: 20px;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.blog-title {\r\n  line-height: 1.5;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .blog-card {\r\n    height: 440px;\r\n  }\r\n\r\n  .blog-paragraph {\r\n    padding-top: 5px;\r\n  }\r\n}\r\n@media (max-width: 576px) {\r\n  .blog-cover-img {\r\n    height: 170px;\r\n  }\r\n  .blog-image {\r\n    object-fit: cover;\r\n  }\r\n\r\n  .blog-card {\r\n    height: 335px;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .blog-content {\r\n    padding: 20px 15px;\r\n  }\r\n\r\n  .blog-paragraph {\r\n    padding-top: 5px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\r\n  .blog-card {\r\n    height: 520px;\r\n  }\r\n\r\n  .blog-title {\r\n    line-height: 1.5;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
